export const LOADERS = new Map();

export const STATES = Object.freeze({
  INITIALIZED: 0,
  LOADING: 1,
  SUCCESS: 2,
  ERROR: 3,
  TIMEOUT: 4,
});
